import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('fish', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("g", {
    "clip-path": 'url(#' + props.id + '43c453d0' + ')'
  }, [_createVNode("path", {
    "d": "M15.3808 32.8442C9.72351 31.4296 0.531437 34.9654 9.72365 38.5008C13.2595 47.6935 16.7947 38.5008 15.3808 32.8442Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M22.4823 10.2474C17.5789 10.2343 11.2504 11.7843 10.4533 13.9753C9.87553 15.5636 12.878 17.6766 16.7036 18.7931",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M37.9776 25.7423C37.9907 30.6457 36.4407 36.9743 34.2497 37.7713C32.6614 38.3491 30.5484 35.3466 29.4319 31.521",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M37.9993 25.7649C44.6625 19.7001 40.1249 8.09147 40.1249 8.09147C40.1249 8.09147 28.1079 4.55981 22.4511 10.2167C16.7942 15.8735 15.38 32.8441 15.38 32.8441C15.38 32.8441 31.3362 31.8297 37.9993 25.7649Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M38.0075 25.773C38.0075 25.773 31.29 24.7124 27.4009 20.8233C23.5118 16.9342 22.4512 10.2167 22.4512 10.2167",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("circle", {
    "cx": "33.7656",
    "cy": "14.4593",
    "r": "2",
    "transform": "rotate(45 33.7656 14.4593)",
    "fill": props.colors[2]
  }, null), _createVNode("path", {
    "d": "M40.9998 20.9448C40.4591 22.7045 39.5215 24.3794 37.9993 25.7649C36.3518 27.2643 34.1363 28.4551 31.7344 29.3981",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M27.0002 7.65639C25.3026 8.1445 23.7176 8.95037 22.4513 10.2167C21.2665 11.4015 20.2678 13.0825 19.4293 15",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]), _createVNode("defs", null, [_createVNode("clipPath", {
    "id": props.id + '43c453d0'
  }, [_createVNode("rect", {
    "width": "48",
    "height": "48",
    "fill": props.colors[2]
  }, null)])])]);
});